module.exports = __webpack_public_path__ + "static/media/lexus-parking-selected.8d02a777.svg";